"use client"

import Autoplay from "embla-carousel-autoplay"
import { useEffect, useState } from "react"
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "./ui/carousel"

const CARDS = [
	{ index: 1, href: "https://goo.gle/santamainb" },
	{ index: 2, href: "https://goo.gle/santamaina" },
	{ index: 3, href: "https://goo.gle/santachallenge4" },
	{ index: 4, href: "https://goo.gle/santachallenge5" },
	{ index: 5, href: "https://goo.gle/santachallenge3" }
]

export function MobileView() {
	return (
		<div className="relative min-h-screen flex flex-col items-center overflow-x-hidden lg:hidden">
			<img src="/assets/images/noise_finish2.png" alt="noise" className="absolute inset-0 w-full h-full object-cover opacity-50 mix-blend-lighten" />

			<img src="/assets/images/snow_finish2.png" alt="snow" className="absolute top-[10%] left-[5%] mix-blend-lighten scale-80 rotate-180 hidden sm:flex" />
			<img src="/assets/images/snow_finish2.png" alt="snow" className="absolute top-[12%] left-[84%] mix-blend-lighten scale-80 rotate-90 hidden sm:flex" />
			<img src="/assets/images/snow_finish2.png" alt="snow" className="absolute top-[28%] left-[10%] mix-blend-lighten scale-70 rotate-180 hidden sm:flex" />
			<img src="/assets/images/snow_finish2.png" alt="snow" className="absolute top-[25%] left-[78%] mix-blend-lighten scale-70 hidden sm:flex" />

			<img src="/assets/images/star_finish2.png" alt="star" className="absolute top-[25%] left-[5%] mix-blend-lighten scale-70 hidden sm:flex" />
			<img src="/assets/images/star_finish2.png" alt="star" className="absolute top-[32%] left-[90%] mix-blend-lighten scale-70 hidden sm:flex" />

			<div className="w-full flex flex-col items-center justify-center gap-6 mix-blend-lighten mt-10 mb-6">
				<img src="/assets/images/logo_finish2.png" className="h-[18px] sm:h-[21px]" alt="logo" />
				<img src="/assets/images/visual_m_finish2.png" className="w-full sm:w-[80%] md:w-[60%]" alt="santa visual" />
				<img src="/assets/images/description_finish2.png" className="w-[90%] sm:w-[70%] md:w-[50%]" alt="description" />
			</div>

			<MobileCarousel />

			<img src="/assets/images/annotation_finish2.png" className=" h-[16px] md:h-[18px] mix-blend-lighten mt-auto mb-5" alt="annotation" />
		</div>
	)
}

function MobileCarousel() {
	const [api, setApi] = useState<CarouselApi>()
	const [isScrolling, setIsScrolling] = useState(true)
	const [autoplayPlugin] = useState(() =>
		Autoplay({
			delay: 4000,
			stopOnInteraction: true,
			stopOnMouseEnter: true
		})
	)

	useEffect(() => {
		if (!api) return

		const timer = setTimeout(() => {
			api.scrollTo(0)
		}, 500)

		return () => clearTimeout(timer)
	}, [api])

	useEffect(() => {
		if (!api) return

		const onScroll = () => setIsScrolling(true)
		const onSettle = () => setIsScrolling(false)

		api.on("scroll", onScroll)
		api.on("settle", onSettle)

		return () => {
			api.off("scroll", onScroll)
			api.off("settle", onSettle)
		}
	}, [api])

	return (
		<section className="relative w-full mb-6">
			{/* handle */}
			<img
				src="/assets/images/handle_finish2.gif"
				className={`absolute left-[72%] sm:left-[65%] translate-x-[-50%] h-[100px] z-50 transition-[opacity,top] duration-300 ease-out pointer-events-none ${isScrolling ? "opacity-0 top-12" : "opacity-100 top-10"}`}
				alt="cursor"
			/>

			<Carousel
				opts={{
					align: "center",
					loop: true,
					startIndex: 4
				}}
				plugins={[autoplayPlugin]}
				setApi={setApi}
				className="w-full"
			>
				<CarouselContent className="ml-0">
					{CARDS.map((card) => (
						<CarouselItem key={card.index} className="basis-[65%] sm:basis-[55%] md:basis-[40%] pl-0 mx-3 flex justify-center aspect-212/257">
							<a id={card.href.split("/").pop()} href={card.href} target="_blank" rel="noopener noreferrer" className="w-full h-full">
								<img
									src={`/assets/images/photo${card.index}_m_finish2.webp`}
									className="w-full h-full object-cover"
									style={{ filter: "drop-shadow(9px 9px 10px rgba(0, 0, 0, 0.2))" }}
									alt={`photo${card.index}`}
								/>
							</a>
						</CarouselItem>
					))}
				</CarouselContent>
			</Carousel>
		</section>
	)
}
